import '@styles/components/appBannerCSC.less';
//import history from '@tools/history';
import { setTryOutDialog } from '@store/appSlice';
import { useAppDispatch } from '@hooks/reduxHooks';

const AppBannerCSC = () => {
  const dispatch = useAppDispatch();

  return (
    <div className={'app-banner'}>
      <img className={'banner-bg'} src={require('@images/common/qldsBg.png').default} alt="" />
      <div className={'content'}>
        <div className={'logo'}>
          <img src={require('@images/common/kshps.png').default} alt="" />
        </div>
        <div className={'title'}>
          <span>方案设计评审系统</span>
        </div>
        <div className={'desc'}>二、三维设计成果智能评审 </div>
        <div className={'theme'}>
          <img src={require('@images/common/faps.png').default} alt="" />
          <span>方案设计评审系统</span>
          <p>二、三维设计成果智能评审</p>
        </div>
        <div className={'operate'}>
          <span className={'free-csc'} onClick={() => dispatch(setTryOutDialog(true))}>
            申请试用
          </span>
          {/* <span className={'buy'} onClick={() => history.push('/buy')}>
            立即购买
          </span> */}
        </div>
      </div>
    </div>
  );
};

export default AppBannerCSC;
